import React from "react";
import { Instagram, Facebook, Linkedin, Youtube, Twitter, MessageCircle } from "lucide-react";
import { BRAND } from "../../constants/brand";

const ITEMS = [
  { href: BRAND.social.instagram, icon: Instagram, label: "Instagram", testid: "rail-instagram" },
  { href: BRAND.social.facebook, icon: Facebook, label: "Facebook", testid: "rail-facebook" },
  { href: BRAND.social.linkedin, icon: Linkedin, label: "LinkedIn", testid: "rail-linkedin" },
  { href: BRAND.social.youtube, icon: Youtube, label: "YouTube", testid: "rail-youtube" },
  { href: BRAND.social.twitter, icon: Twitter, label: "X", testid: "rail-twitter" },
  { href: BRAND.social.whatsapp, icon: MessageCircle, label: "WhatsApp", testid: "rail-whatsapp" },
];

export default function SocialRail() {
  return (
    <div className="pointer-events-none fixed right-3 top-1/2 z-30 hidden -translate-y-1/2 md:block" data-testid="social-rail">
      <div className="pointer-events-auto flex flex-col gap-2 rounded-full border border-neutral-200 bg-white/95 p-2 shadow-sm backdrop-blur">
        {ITEMS.map((it) => (
          <a
            key={it.label}
            href={it.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={it.label}
            data-testid={it.testid}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-transparent text-neutral-700 transition-colors hover:border-neutral-900 hover:bg-lime-400 hover:text-neutral-950"
          >
            <it.icon size={16} />
          </a>
        ))}
      </div>
    </div>
  );
}
